import { URLS } from "@/data/constants";
import { Button } from "@/components/design-system/Button/Button";
import { trackCalendlyClick } from "@/utils/analytics";
import React from "react";
import { IconCheckCircle } from "@/components/design-system/basic-icons/IconCheckCircle";

type CheckItem = {
  readonly text: string;
};

const checkItems: readonly CheckItem[] = [
  {
    text: "See how Bravo reduces stress-driven turnover and absenteeism across your workforce",
  },
  {
    text: "Model the annual ROI for your specific headcount, salaries and turnover rate",
  },
  {
    text: "Explore how Bravo plugs into your existing benefits stack with minimal lift",
  },
  {
    text: "Understand how real-time signals give HR visibility into financial wellbeing",
  },
] as const;

export const EmployerGetStartedSection: React.FC = () => {
  const handleCalendlyClick = () => {
    trackCalendlyClick("emp_get_started");
    window.open(URLS.CALENDLY, "_blank");
  };

  return (
    <section className="bg-primary-50 w-full overflow-hidden">
      <div className="mx-auto max-w-360 px-5 py-16 md:px-8 md:py-24 lg:px-16">
        <div className="flex flex-col gap-6 md:grid md:grid-cols-2 md:gap-x-12 md:gap-y-6">
          <p className="caption-bold uppercase text-black md:col-start-1 md:row-start-1 md:text-right">
            Get Started
          </p>

          <div className="md:col-start-1 md:row-start-2 md:flex md:justify-end">
            <div className="flex w-full flex-col gap-4 md:max-w-118.25 md:gap-6">
              <h2 className="headline-d-extrabold md:headline-c-extrabold text-black md:text-right">
                See Bravo{" "}
                <span className="text-primary-500">in action.</span>
              </h2>
              <p className="body-a-regular md:subtitle-b-regular text-black md:text-right">
                Book a 45-minute demo and we'll show you exactly how Bravo
                integrates with your benefits stack and model the potential ROI
                for your organisation.
              </p>
              <Button
                variant="solid"
                size="lg"
                onClick={handleCalendlyClick}
                className="hover:bg-primary-700 h-10 w-full px-4 text-base font-normal transition md:w-auto md:self-end lg:h-12 lg:px-6 lg:text-lg"
              >
                Book a demo
              </Button>
            </div>
          </div>

          <div className="md:col-start-2 md:row-start-2 md:flex md:items-start">
            <div className="flex w-full flex-col gap-6 rounded-2xl drop-shadow-[0px_0px_32px_#dfc5e0] md:max-w-114">
              {checkItems.map((item) => (
                <div key={item.text} className="flex items-start gap-3">
                  <IconCheckCircle
                    fillColor="var(--color-primary-50)"
                    strokeColor="var(--color-primary-500)"
                    className="mt-0.5 h-6 w-6 shrink-0"
                  />
                  <span className="body-b-regular text-black">
                    {item.text}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
